/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteMaintenanceTyreTestsParams,
  GetMaintenanceTyreTestsParams,
  MaintenanceTyreTests,
  MaintenanceTyreTestsInsertPayload,
  MaintenanceTyreTestsUpdate,
  PatchMaintenanceTyreTestsParams,
  PostMaintenanceTyreTestsParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getMaintenanceTyreTestsResponse200 = {
  data: MaintenanceTyreTests[]
  status: 200
}

export type getMaintenanceTyreTestsResponse206 = {
  data: MaintenanceTyreTests[]
  status: 206
}

export type getMaintenanceTyreTestsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getMaintenanceTyreTestsResponseSuccess = (getMaintenanceTyreTestsResponse200 | getMaintenanceTyreTestsResponse206) & {
  headers: Headers;
};
export type getMaintenanceTyreTestsResponseError = (getMaintenanceTyreTestsResponseDefault) & {
  headers: Headers;
};

export type getMaintenanceTyreTestsResponse = (getMaintenanceTyreTestsResponseSuccess | getMaintenanceTyreTestsResponseError)

export const getGetMaintenanceTyreTestsUrl = (params?: GetMaintenanceTyreTestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_tyre_tests?${stringifiedParams}` : `${backendBaseUrl}/maintenance_tyre_tests`
}

/**
 * @summary Read rows from `maintenance_tyre_tests`.
 */
export const getMaintenanceTyreTests = async (params?: GetMaintenanceTyreTestsParams, options?: RequestInit): Promise<getMaintenanceTyreTestsResponse> => {

  const res = await fetch(getGetMaintenanceTyreTestsUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getMaintenanceTyreTestsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getMaintenanceTyreTestsResponse
}


export type postMaintenanceTyreTestsResponse201 = {
  data: MaintenanceTyreTests[]
  status: 201
}

export type postMaintenanceTyreTestsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postMaintenanceTyreTestsResponseSuccess = (postMaintenanceTyreTestsResponse201) & {
  headers: Headers;
};
export type postMaintenanceTyreTestsResponseError = (postMaintenanceTyreTestsResponseDefault) & {
  headers: Headers;
};

export type postMaintenanceTyreTestsResponse = (postMaintenanceTyreTestsResponseSuccess | postMaintenanceTyreTestsResponseError)

export const getPostMaintenanceTyreTestsUrl = (params?: PostMaintenanceTyreTestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_tyre_tests?${stringifiedParams}` : `${backendBaseUrl}/maintenance_tyre_tests`
}

/**
 * @summary Insert one or more rows into `maintenance_tyre_tests`.
 */
export const postMaintenanceTyreTests = async (maintenanceTyreTestsInsertPayload: MaintenanceTyreTestsInsertPayload,
    params?: PostMaintenanceTyreTestsParams, options?: RequestInit): Promise<postMaintenanceTyreTestsResponse> => {

  const res = await fetch(getPostMaintenanceTyreTestsUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceTyreTestsInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postMaintenanceTyreTestsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postMaintenanceTyreTestsResponse
}


export type patchMaintenanceTyreTestsResponse200 = {
  data: MaintenanceTyreTests[]
  status: 200
}

export type patchMaintenanceTyreTestsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchMaintenanceTyreTestsResponseSuccess = (patchMaintenanceTyreTestsResponse200) & {
  headers: Headers;
};
export type patchMaintenanceTyreTestsResponseError = (patchMaintenanceTyreTestsResponseDefault) & {
  headers: Headers;
};

export type patchMaintenanceTyreTestsResponse = (patchMaintenanceTyreTestsResponseSuccess | patchMaintenanceTyreTestsResponseError)

export const getPatchMaintenanceTyreTestsUrl = (params?: PatchMaintenanceTyreTestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_tyre_tests?${stringifiedParams}` : `${backendBaseUrl}/maintenance_tyre_tests`
}

/**
 * @summary Update the rows of `maintenance_tyre_tests` matching the given filters.
 */
export const patchMaintenanceTyreTests = async (maintenanceTyreTestsUpdate: MaintenanceTyreTestsUpdate,
    params?: PatchMaintenanceTyreTestsParams, options?: RequestInit): Promise<patchMaintenanceTyreTestsResponse> => {

  const res = await fetch(getPatchMaintenanceTyreTestsUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceTyreTestsUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchMaintenanceTyreTestsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchMaintenanceTyreTestsResponse
}


export type deleteMaintenanceTyreTestsResponse200 = {
  data: MaintenanceTyreTests[]
  status: 200
}

export type deleteMaintenanceTyreTestsResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteMaintenanceTyreTestsResponseSuccess = (deleteMaintenanceTyreTestsResponse200) & {
  headers: Headers;
};
export type deleteMaintenanceTyreTestsResponseError = (deleteMaintenanceTyreTestsResponseDefault) & {
  headers: Headers;
};

export type deleteMaintenanceTyreTestsResponse = (deleteMaintenanceTyreTestsResponseSuccess | deleteMaintenanceTyreTestsResponseError)

export const getDeleteMaintenanceTyreTestsUrl = (params?: DeleteMaintenanceTyreTestsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_tyre_tests?${stringifiedParams}` : `${backendBaseUrl}/maintenance_tyre_tests`
}

/**
 * @summary Delete the rows of `maintenance_tyre_tests` matching the given filters.
 */
export const deleteMaintenanceTyreTests = async (params?: DeleteMaintenanceTyreTestsParams, options?: RequestInit): Promise<deleteMaintenanceTyreTestsResponse> => {

  const res = await fetch(getDeleteMaintenanceTyreTestsUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteMaintenanceTyreTestsResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteMaintenanceTyreTestsResponse
}


